import { usePathname } from 'next/navigation'

export const getDarkMode = (pathname: string): boolean => {
	return (
		(!pathname.includes('/videoNews') && pathname.includes('/video')) ||
		pathname.includes('/shorts')
	)
}

export const useDarkModeControl = () => {
	const pathname = usePathname()
	const fixedDarkMode = getDarkMode(pathname)

	return {
		darkMode: fixedDarkMode,
	}
}
